import {invoicesService} from "@/_services";
import router from "@/router";

export default {
  getAll({dispatch, commit}, {page, sort, search}) {
    dispatch("alert/clear", {}, { root: true });
    invoicesService.getAll(page)
      .then(
        invoices => {
          commit("setInvoicesData", invoices);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  bill({dispatch, commit}, {taxDataId, invoiceId}) {
    dispatch("alert/clear", {}, { root: true });
    return invoicesService.bill(taxDataId, invoiceId)
      .then(
        invoice => {
          dispatch("invoices/getAll", {}, {root:true});
          dispatch("alert/success", "La factura se realizó con éxito", { root: true });
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, { root: true });
          return Promise.reject();
        }
      )
  },
  downloadPdfXml({dispatch, commit}, {invoiceId, type}) {
    dispatch("alert/clear", {}, { root: true });
    invoicesService.downloadPdfOrXml(invoiceId, type)
      .then(
        () => {
          dispatch("alert/success", "Se ha descargado la factura en " + type.toUpperCase(), { root: true });
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  }
}
